import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// A Foundation object revision on its own. Relationships are NOT a member here: they hang off the
// LOGICAL object rather than the revision, so the detail page loads them through their own
// EnterpriseObject keyed on ParentUSID instead of following the selected revision.
class ObjectRevisionEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ObjectRevision";
        this.primaryEnterpriseComponent = "ObjectRevision";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ObjectRevision";
        eom.enterpriseComponent = "ObjectRevision";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ObjectRevisionEnterpriseObjectMetadata;
